import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import GeneratorView from '@/views/GeneratorView.vue'
import InventarizationView from '@/views/Inventarization.vue'
import DashboardView from '@/views/DashboardView.vue'
import AuthView from '@/views/AuthView.vue'
import SettingsView from '@/views/SettingsView.vue'
import { checkAuth } from '@/auth/auth.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/gen',
    name: 'generator',
    component: GeneratorView,
    meta: { requiresAuth: true }
  },
  {
    path: '/inv',
    name: 'inventarization',
    component: InventarizationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dash',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'AuthView',
    component: AuthView
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: SettingsView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Закрытые страницы доступны только авторизованным пользователям
router.beforeEach((to) => {
  if (to.meta.requiresAuth && !checkAuth()) {
    return { name: 'AuthView' }
  }

  return true
})

export default router
